import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import FormBuilder from "@/pages/FormBuilder";
import MenuBuilder from "@/pages/MenuBuilder";
import FormSubmissions from "@/pages/FormSubmissions";
import MenuOrders from "@/pages/MenuOrders";
import PublicForm from "@/pages/PublicForm";
import PublicMenu from "@/pages/PublicMenu";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 font-display text-2xl">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/f/:slug" element={<PublicForm />} />
          <Route path="/m/:slug" element={<PublicMenu />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/forms/new" element={<Protected><FormBuilder /></Protected>} />
          <Route path="/forms/:id" element={<Protected><FormBuilder /></Protected>} />
          <Route path="/forms/:id/submissions" element={<Protected><FormSubmissions /></Protected>} />
          <Route path="/menus/new" element={<Protected><MenuBuilder /></Protected>} />
          <Route path="/menus/:id" element={<Protected><MenuBuilder /></Protected>} />
          <Route path="/menus/:id/orders" element={<Protected><MenuOrders /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
